require('./lbaPolicyCodeSelect.scss');

const $inject = [];

const lbaPolicyCodeSelect = function () {
  return {
    restrict: 'A',
    scope:{
      settings: '<',
    },
    bindToController: true,
    controller: 'lbaPolicyCodeSelectCtrl',
    controllerAs: 'vm',
    template: require('./lbaPolicyCodeSelect.html')
  }
};

lbaPolicyCodeSelect.$inject = $inject;

export default lbaPolicyCodeSelect;



// WEBPACK FOOTER //
// ./src/components/lbaPolicyCodeSelect/lbaPolicyCodeSelectDir.js